/* eslint-disable react/prefer-stateless-function,react/require-default-props,react/destructuring-assignment,react/no-array-index-key,react/no-danger */

import React from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {
  PortalCoursePropType,
  CourseOutcomePropType,
} from '../../../../CustomPropTypes/PortalPropTypes';
import { PortalJoinCourseButton } from '../../PortalButton/PortalJoinCourseButton';
import './PortalOutcomes.scss';

class _PortalOutcomes extends React.Component {
  static displayName = 'PortalOutcomes';

  static propTypes = {
    anchor: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    content: PropTypes.string,
    outcomes: ImmutablePropTypes.listOf(CourseOutcomePropType.isRequired),
    showObjective: PropTypes.bool,
    objective: PropTypes.string,
    furtherInformation: PropTypes.string,
    course: PortalCoursePropType.isRequired,
    onCtaButtonClicked: PropTypes.func,
    onEnrolInCourse: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
  };

  render() {
    const {
      anchor,
      title,
      content,
      furtherInformation,
      outcomes,
      course,
      showObjective,
      objective,
      onEnrolInCourse,
      onCtaButtonClicked,
      t,
    } = this.props;

    const hasOutcomes = !!outcomes.size;
    const hasObjective = showObjective && objective;

    return (
      <portal-outcomes id={anchor}>
        <div className="row portal-section">
          <div className="columns small-11 small-centered medium-10 medium-centered">
            <h2>{title}</h2>
            <h4 className="portal-section-blurb">{content}</h4>
            {hasOutcomes && (
              <h3 className="portal-outcomes-sub-heading">
                {t('course_outcomes')}
              </h3>
            )}
            {(hasOutcomes || hasObjective) && (
              <ul className="portal-bullet-list">
                {hasObjective && <li className="no-bullet">{objective}</li>}
                {outcomes.map((outcome, i) => (
                  <li key={i}>{outcome.get('description')}</li>
                ))}
              </ul>
            )}
            {furtherInformation ? (
              <div
                className="further-information"
                dangerouslySetInnerHTML={{ __html: furtherInformation }}
              />
            ) : null}
            <div className="call-to-action">
              <PortalJoinCourseButton
                enrolInCourse={onEnrolInCourse}
                {...{ course, onCtaButtonClicked }}
              />
            </div>
          </div>
        </div>
      </portal-outcomes>
    );
  }
}

export const PortalOutcomes = withTranslation('landingPages')(_PortalOutcomes);
